export default function formatOptionLabel({ label, color , type}) {
  const displayLabel = type === "chipset" ? label.toUpperCase() : label;

  return (
    <div className="d-flex align-items-center">
      <div
        style={{
          display: "inline-block",
          width: "10px",
          height: "10px",
          backgroundColor: color,
          borderRadius: "50%",
          margin: "2px",
        }}
      ></div>

      {displayLabel}
    </div>
  );
}
